import { Route, Routes as ReactRoutes } from 'react-router-dom';

import { Page404 } from 'components';

import { useUserRole } from 'hooks';

import { privateRoutes } from './config';
import { PrivateRoute } from './PrivateRoute';

export const Routes = () => {
  const { isAdmin } = useUserRole();

  return (
    <ReactRoutes>
      {privateRoutes(isAdmin).map(({ path, element: Element }) => (
        <Route
          key={path}
          path={path}
          element={<PrivateRoute component={Element} />}
        />
      ))}

      <Route
        path='*'
        element={<Page404 />}
      />
    </ReactRoutes>
  );
};
